export enum RoleEnum {
  // 管理员
  ADMIN = 'admin',

  // 普通用户
  NORMAL = 'normal',

  // 客服
  KEFU = 'kefu',

  // 普通用户角色
  USER = 'user',

  // 系统
  SYSTEM = 'system',
}

export enum SendTypeEnum {
  // 系统
  SYSTEM = 0,
  // 客服
  KEFU = 1,
  // 客户
  USER = 2,
}

export enum UserTypeEnum {
  // 系统管理员
  ADMIN = 0,
  // 客服主管
  KEFU_MANAGER = 10,
  // 客服
  KEFU = 20,
  // 电商园
  DSY = 30,
}
